import Class from "../assets/images/Class.svg"
import Other from "../assets/images/Other.svg"
import Staff from "../assets/images/Staff.svg"
import PLC from "../assets/images/PLC.svg"
import Public from "../assets/images/Public.svg"
import Private from "../assets/images/Private.svg"

export const APIStatus = {
    success: 200,
}

export const TeamTemplates = {
    STANDARD: 1,
    EDUCATION_CLASS: 2,
    EDUCATION_STAFF: 3,
    EDUCATION_PLC: 4,
}

export const templateList = [
    { id: 2, name: "Class", description: "Discussions, group projects, assignments", image: Class },
    { id: 4, name: "Professional Learning Community (PLC)", description: "Educator working group", image: PLC },
    { id: 3, name: "Staff", description: "School administration and development", image: Staff },
    { id: 1, name: "Other", description: "Clubs, study groups, after school activities", image: Other },
]

export const templateDetail = {
    2: "Teachers are owners of class teams and students participate as members. Each class team allows you to create assignments and quizzes, record student feedback, and give your students a private space for notes in Class Notebook.",
    4: "Educators work together on shared goals or professional development. Each PLC team allows you to organise materials, collaborate, and access a OneNote notebook populated with templates for common PLC tasks.",
    3: "Staff leaders are owners of staff teams and add others as members. Each staff team allows you to communicate, share important documents, and set up a Staff Notebook to track common administrative goals.",
    1: "Educators or students can create teams to work together on any shared goal, project, or activity."
}

export const privacy = [
    { id: 0, name: "Private", description: "People need permission to join", image: Private },
    { id: 1, name: "Public", description: "Anyone in your org can join", image: Public },
]